<template>
  <footer class="site-footer relative self-end w-full bg-brand-blue text-white footer" itemscope itemtype="https://schema.org/WPFooter">

    <nav role="navigation" class="footer-nav mx-auto">

      <div class="w-full lg:flex-1">
        <h3 class="column-title">Sammen på vei</h3>
        <ul>
          <li>
            <router-link to="/for-gravide">For gravide</router-link>
          </li>
          <li>
            <router-link to="/for-henvisning">For henvisning</router-link>
          </li>
          <li>
            <router-link to="/om-oss">Om oss</router-link>
          </li>
          <li>
           <router-link to="/kunnskapsgrunnlag">Kunnskapsgrunnlag</router-link>
          </li>
        </ul>
      </div>

      <div class="w-full lg:flex-1">
        <h3 class="column-title">Snarveier</h3>
        <ul>
          <li
          v-for="item in menu" :key="item.id" :data-id="item.id">
            <router-link :to="relativeURL(Number(item.id))">{{ item.title }}</router-link>
          </li>
        </ul>
      </div>

      <address class="w-full lg:flex-1">
        <h3 class="column-title">Kontakt</h3>
        <ul>
          <li>RBUP: Regionsenter for barn <br />og unges psykiske helse</li>
          <li>Gullhaugveien 1-3</li>
          <li>0484 Oslo</li>
          <li class="mt-8">Org.nr. 980 633 004</li>
        </ul>
      </address>

      <div class="flex-none order-2 lg:-order-none self-end lg:self-start lg:flex-none text-white">
        <svg class="w-24 lg:w-28 h-auto fill-current" aria-hidden="true" data-name="Icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 393.53 316.86">
          <path class="icon-1"
            d="M289.42,323.51a94.17,94.17,0,0,1-23.53-2.89c-14.15-3.64-23.78-11.71-27.09-22.72a30.74,30.74,0,0,1,10.51-32.73c9.49-7.69,21.48-9.39,32.07-10.9,2-.28,4-.56,5.95-.89l4.9-.76c11.67-1.77,26.19-4,32.2-12.05a8.82,8.82,0,0,0,.7-1.17,11.27,11.27,0,0,0-3.84-14.15c-5.21-3.51-11.22-1.08-20.51,3.34-1.55.74-3.08,1.46-4.56,2.11-1.28.57-2.59,1.25-3.92,2-6.68,3.46-17.85,9.27-28.1.38-12.06-10.46-4.92-24.42-1.09-31.92.53-1,1-2,1.49-3,4.33-9.07,3.25-23.11-6.06-30-7.33-5.39-16.07-5.49-22.81-.26-6.94,5.39-9.95,16.63-7,26.13a50,50,0,0,0,3.59,7.86c3.25,6.18,7.29,13.88,5.51,23.22C235.7,236.4,227,242.44,220,247.3a57,57,0,0,0-7.81,6.08c-9.86,10-10.41,26.76-10.89,41.57-.21,6.32-.21,13.05,0,20.74l-15.21.38c-.2-8-.2-15,0-21.45.56-16.9,1.24-37.72,15.29-51.94a68.61,68.61,0,0,1,9.94-7.88c6.58-4.57,10.65-7.7,11.56-12.51.75-3.93-1-7.62-4-13.31a62.09,62.09,0,0,1-4.65-10.41c-4.82-15.5.31-33.45,12.2-42.67,12.16-9.44,28.31-9.43,41.16,0,14.13,10.4,18.87,31.83,10.78,48.78-.52,1.08-1.09,2.2-1.68,3.35-4.74,9.27-4.78,11.49-2.5,13.48,2,1.72,4.07,1.28,11.12-2.39,1.55-.81,3.16-1.64,4.8-2.36,1.35-.6,2.75-1.26,4.16-1.94,9.62-4.57,22.78-10.83,35.56-2.21a26.39,26.39,0,0,1,8.93,33.6,22.94,22.94,0,0,1-2.08,3.41c-9.74,13.12-27.71,15.84-42.14,18l-4.72.73c-2.06.34-4.16.64-6.27.94-9.47,1.35-18.41,2.62-24.64,7.66a15.76,15.76,0,0,0-5.5,16.52c2.31,7.7,11.21,11.05,16.31,12.36,18.41,4.74,41.18,2.24,64.1-7.05,22.51-9.12,38.85-24.34,46-42.86,6.69-17.29,5.8-34.07-2.64-49.87-15.78-29.53-54.21-49.78-85.3-56.75-14.73-3.31-24.7-8.25-28.87-22.69-3.51-12.12,2.49-23.75,7.32-33.1a86.53,86.53,0,0,0,4.66-10c3.73-10.61,3.55-21.43-.5-29.7-3.48-7.12-9.61-12.18-18.22-15.05a25.31,25.31,0,0,0-23.12,3.42,34.68,34.68,0,0,0-14.56,26.28c-.4,10.38,3.46,18,7.21,25.47,3.28,6.51,6.67,13.24,6.81,21.18.45,24.78-25.43,36.14-40.89,42.92s-31.46,11.49-47,16.08c-13.87,4.09-28.23,8.32-41.62,13.88l-.38.16c-6.55,2.71-14.7,6.09-18.11,10.94-3.12,4.43-3.25,12,1.54,15.76,5.63,4.45,13.16,3.16,26-4.42,2-1.15,4.09-2.51,6.38-4,15.42-9.78,38.73-24.55,57.49-11.75,10.83,7.38,13,16.77,13,23.34-.19,19-19.15,38.3-31.85,46.6-29.84,19.51-72.14,25.7-102.87,15.06C32.38,272.23,17.05,257,9.86,235.6c-11.69-34.7,3.49-71.15,38.67-92.86,3.38-2.09,7.24-4.21,11.33-6.47,13.64-7.53,30.63-16.9,35.62-28.42,2.69-6.19-2.14-14.39-6.81-22.32-1.43-2.42-2.77-4.7-3.94-7a47.53,47.53,0,0,1-4.16-32.46c5.2-22.88,25.34-39.85,46.79-39.42A42.55,42.55,0,0,1,159.12,22a52.28,52.28,0,0,1,11.63,41.1c-1.52,11.13-6.21,19.14-10.35,26.2-3.73,6.37-6.67,11.39-6.53,17.28.09,3.57,1.67,6.36,4.36,7.67,5,2.41,13,.07,21.47-6.26l9.1,12.2c-13.33,10-26.91,12.77-37.23,7.74-7.86-3.82-12.69-11.66-12.91-21-.25-10.22,4.25-17.91,8.61-25.35,3.75-6.39,7.29-12.43,8.4-20.55a37,37,0,0,0-8.11-29.15,27.53,27.53,0,0,0-20.49-10c-16.4-.41-28.57,14-31.65,27.58a32,32,0,0,0,2.87,22.17c1,1.88,2.19,4,3.49,6.18,5.67,9.63,13.43,22.81,7.66,36.11-7.06,16.27-26.56,27-42.23,35.69-3.92,2.16-7.62,4.2-10.69,6.09C27.59,173.54,14.94,203,24.28,230.74c5.71,17,17.45,28.63,34.88,34.67,26.14,9,63.81,3.41,89.56-13.42,10.39-6.79,24.84-22.39,25-34,0-2.69-.6-6.72-6.31-10.62-10.51-7.16-28,3.94-40.78,12-2.43,1.54-4.7,3-6.77,4.21-7.39,4.37-27,16-43.16,3.27-12-9.47-11.71-26.3-4.56-36.47,6-8.46,16.37-12.77,24.73-16.24l.37-.16c14.15-5.87,28.9-10.22,43.16-14.42,15.12-4.45,30.75-9.06,45.21-15.41,16.22-7.12,32-15.21,31.79-28.72-.08-4.46-2.44-9.16-5.18-14.6-4.18-8.29-9.39-18.61-8.83-32.91a49.74,49.74,0,0,1,21.11-38.21,40.53,40.53,0,0,1,36.6-5.34c12.44,4.15,21.8,12,27.07,22.8,5.83,11.9,6.26,27,1.19,41.44a97.2,97.2,0,0,1-5.5,11.91c-4,7.67-8.05,15.59-6.22,21.89,1.74,6,3.93,9,17.58,12.06,34.47,7.73,77.34,30.66,95.39,64.44,10.62,19.88,11.77,40.91,3.42,62.53-8.68,22.47-28,40.76-54.48,51.47C326.43,318.24,308.6,323.51,289.42,323.51Z"
            transform="translate(-5.97 -6.65)" />
        </svg>
      </div>

      <div class="bottom-links ">
        <p class="mb-0 regular"><router-link to="/personvern">Personvern</router-link></p>
        <p class="mb-0 regular"><router-link to="/informasjonskapsler">Informasjonskapsler (cookies)</router-link></p>
        <p class="mb-0 regular"><a target="_blank" href="https://uustatus.no/nb/erklaringer/publisert/894fbd92-4532-44ac-a4a8-0f59b063354d">Tilgjengelighetserklæring</a></p>
        <p class="mb-0 regular lg:order-first">2022 &copy; RBUP: Regionsenter for barn og unges psykiske helse</p>
      </div>

    </nav>

  </footer>
</template>

<script>
export default {
  data : () => ({
    menu: [],
    baseURL: process.env.MIX_API_BASE_URL,
  }),

  methods: {
    async getMenu() {
      try {
        const response = await axios.get(
          this.baseURL + '/api/menus/v1/menus/67', {
            params: {}
          }
        )
        const results = response.data
        if ( !results || results.length == 0 ) {}
        this.menu = results.map(post => ({
          id: post.object_id,
          type: post.object,
          title: post.title,
        }))
      }
      catch (e) {
        console.error(e);
        // this.errors.push(e)
      }
      // return this.doAction()

    },

    relativeURL(id) {
      return this.$store.getters.getRelativeUrl(id)
//       let filteredPosts = ''
//
//       if ( this.$store.getters.getPagesAndPosts.find( post => post.id === id ) ) {
//         filteredPosts = this.$store.getters.getPagesAndPosts.find( post => post.id === id )
//         filteredPosts = filteredPosts.vueData.url
//       }
//
//       //console.log(filteredPosts)
//       return filteredPosts

    }
  },

  mounted() {
    this.getMenu()
  },

}
</script>
